import React, { useState } from 'react'
import { Modal } from 'antd'
import FilesContent from 'modules/contentManager/FilesContent'
import './CustomMetaFileModal.scss'

const CustomMetaFileModal = ({
  title,
  project,
  visible = false,
  onOk = () => null,
  onCancel = () => null,
  // if passed will show only those folders else will show all folders
  rootFolderItemsToShow = [],
  getContainer = document.body
}) => {
  const [selectedFile, setSelectedFile] = useState(null)
  return (
    <Modal
      title={title}
      visible={visible}
      onOk={() => {
        onOk(selectedFile)
      }}
      onCancel={onCancel}
      className='general-modal file-selector-modal'
      width='calc(100vw - 40px)'
      getContainer={getContainer}
    >
      {
        visible &&
        <FilesContent
          project={project}
          enableUpload
          showFileDetailsSideBar={false}
          enableFolderActions={false}
          enableFolderCreation={false}
          onItemSelect={(itemSelection) => {
            setSelectedFile(itemSelection)
          }}
          rootFolderItemsToShow={rootFolderItemsToShow}
          className='content-manager'
        />
      }
    </Modal>
  )
}

export default CustomMetaFileModal
